/* ez-video-feature.js — lite YouTube embed. A [data-ez-video] player holds a poster button
   [data-ez-video-trigger]; on first click it swaps the poster for a lazy autoplay iframe.
   No third-party JS or network weight until the visitor clicks. */
(function () {
  'use strict';

  function loadVideo(player) {
    var yt = player.getAttribute('data-yt');
    if (!yt || player.getAttribute('data-loaded') === '1') return;
    player.setAttribute('data-loaded', '1');

    var title = player.getAttribute('data-title') || 'Video';
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', 'https://www.youtube.com/embed/' + encodeURIComponent(yt) + '?autoplay=1&rel=0');
    iframe.setAttribute('title', title);
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');

    player.innerHTML = '';
    player.appendChild(iframe);
  }

  /* Modal (lightbox) play mode — opt-in per player via data-ez-video-modal="1". A single shared
     overlay is created on first open and reused. Styles are injected once so the overlay works
     even though it lives on <body>, outside the section's scoped CSS. */
  function ensureModalStyles() {
    if (document.getElementById('ez-vf-modal-styles')) return;
    var st = document.createElement('style');
    st.id = 'ez-vf-modal-styles';
    st.textContent = '.ez-vf-modal{position:fixed;inset:0;z-index:9999;display:none;align-items:center;justify-content:center;padding:clamp(16px,4vw,56px)}.ez-vf-modal.is-open{display:flex}.ez-vf-modal__backdrop{position:absolute;inset:0;background:rgba(8,7,6,.94)}.ez-vf-modal__frame{position:relative;width:min(100%,1120px);aspect-ratio:16/9;background:#000;border-radius:6px;overflow:hidden;box-shadow:0 30px 90px rgba(0,0,0,.55)}.ez-vf-modal__player,.ez-vf-modal__player iframe{width:100%;height:100%;border:0;display:block}.ez-vf-modal__close{position:absolute;top:clamp(12px,3vw,28px);right:clamp(12px,3vw,28px);width:40px;height:40px;padding:0;background:rgba(0,0,0,.4);border:1px solid rgba(250,245,239,.5);border-radius:50%;color:#faf5ef;font-size:22px;line-height:38px;text-align:center;cursor:pointer;z-index:2}.ez-vf-modal__close:hover{background:rgba(0,0,0,.7)}';
    document.head.appendChild(st);
  }

  var modalKeyHandler = null;
  function closeModal() {
    var overlay = document.querySelector('.ez-vf-modal');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    var box = overlay.querySelector('.ez-vf-modal__player');
    if (box) box.innerHTML = '';
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (modalKeyHandler) { document.removeEventListener('keydown', modalKeyHandler); modalKeyHandler = null; }
  }
  function openModal(yt, title) {
    if (!yt) return;
    ensureModalStyles();
    var overlay = document.querySelector('.ez-vf-modal');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'ez-vf-modal';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.innerHTML = '<div class="ez-vf-modal__backdrop" data-ez-modal-close></div><div class="ez-vf-modal__frame"><div class="ez-vf-modal__player"></div></div><button type="button" class="ez-vf-modal__close" data-ez-modal-close aria-label="Close video">&#215;</button>';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', function (e) {
        if (e.target && e.target.hasAttribute('data-ez-modal-close')) closeModal();
      });
    }
    var box = overlay.querySelector('.ez-vf-modal__player');
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', 'https://www.youtube.com/embed/' + encodeURIComponent(yt) + '?autoplay=1&rel=0');
    iframe.setAttribute('title', title || 'Video');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    box.innerHTML = '';
    box.appendChild(iframe);
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    modalKeyHandler = function (e) { if (e.key === 'Escape' || e.keyCode === 27) closeModal(); };
    document.addEventListener('keydown', modalKeyHandler);
  }

  function fallbackCopy(url) {
    try {
      var t = document.createElement('textarea');
      t.value = url; t.setAttribute('readonly', '');
      t.style.position = 'absolute'; t.style.left = '-9999px';
      document.body.appendChild(t); t.select();
      document.execCommand('copy'); document.body.removeChild(t);
    } catch (e) {}
  }

  function flashCopied(btn) {
    var label = btn.querySelector('.ez-vf__share-label');
    var prev = label ? label.textContent : '';
    btn.classList.add('is-copied');
    if (label) label.textContent = 'Copied';
    setTimeout(function () {
      btn.classList.remove('is-copied');
      if (label) label.textContent = prev || 'Share';
    }, 1600);
  }

  // Native OS share sheet where available; else copy the deep-link + flash "Copied".
  function shareVideo(btn) {
    var id = btn.getAttribute('data-share-id');
    if (!id) return;
    var title = btn.getAttribute('data-share-title') || 'EZ-Snap video';
    var url = location.origin + location.pathname + '#v-' + id;
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { flashCopied(btn); }).catch(function () { fallbackCopy(url); flashCopied(btn); });
    } else {
      fallbackCopy(url); flashCopied(btn);
    }
  }

  // Deep link: /pages/videos#v-<yt> scrolls to that video and highlights it.
  function focusHash() {
    var m = (location.hash || '').match(/^#v-(.+)$/);
    if (!m) return;
    var el = document.getElementById('v-' + m[1]);
    if (!el) return;
    try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    catch (e) { el.scrollIntoView(); }
    el.classList.add('is-targeted');
    setTimeout(function () { el.classList.remove('is-targeted'); }, 2600);
  }

  function init() {
    var triggers = document.querySelectorAll('[data-ez-video-trigger]');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', function (e) {
        var player = e.currentTarget.closest('[data-ez-video]');
        if (!player) return;
        if (player.getAttribute('data-ez-video-modal') === '1') {
          openModal(player.getAttribute('data-yt'), player.getAttribute('data-title'));
        } else {
          loadVideo(player);
        }
      });
    }
    var shares = document.querySelectorAll('[data-ez-video-share]');
    for (var j = 0; j < shares.length; j++) {
      shares[j].addEventListener('click', function (e) {
        e.preventDefault();
        shareVideo(e.currentTarget);
      });
    }
    focusHash();
    window.addEventListener('hashchange', focusHash);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
